import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let SystemSamlService = class SystemSamlService {
    constructor(SystemSamlApi) {
        this.SystemSamlApi = SystemSamlApi;
    }
    /**
     * 获取系统 saml 数据
     * @param params
     * @returns
     */
    getSamlQuery(params) {
        return this.SystemSamlApi.getSamlQuery(params);
    }
    /**
     * 删除saml
     * @param id
     * @returns
     */
    deleteSamlById(params) {
        return this.SystemSamlApi.deleteSamlById(params);
    }
    addSystemSaml(params) {
        return this.SystemSamlApi.addSystemSaml(params);
    }
    updatSystemSaml(params) {
        return this.SystemSamlApi.updatSystemSaml(params);
    }
};
SystemSamlService = __decorate([
    injectable(),
    __param(0, inject(Symbols.SystemSamlApi)),
    __metadata("design:paramtypes", [Object])
], SystemSamlService);
export { SystemSamlService };
